import { ReactElement } from 'react';

import { QueueUploadShapefileParam } from './params/QueueUploadShapefileParam';
import { QueueGeopostLayerItemActions } from '../geopostLayer/QueueGeopostLayerItemActions';
import { IItemActionsProps, QueueTypeHandler } from '../QueueTypeHandler';

export class UploadShapefileHandler extends QueueTypeHandler {
    readonly extensionsAccepted: readonly string[] = ['.shp', '.shx', '.dbf', '.prj', '.cpg', '.sbn', '.sbx', '.cst'];
    readonly mainExtensionsToGroup = '.shp';

    renderParams(onParamsChange?: (params: Record<string, unknown>) => void, initialValues?: Record<string, string>): ReactElement {
        return <QueueUploadShapefileParam onParamsChange={onParamsChange} initialValues={initialValues} />;
    }

    renderItemActions(_props: IItemActionsProps): ReactElement {
        return <QueueGeopostLayerItemActions />;
    }
}
